const careerDe = {
  breadcrumbs: { home: 'Startseite', career: 'Karriere' },
  hero: {
    title: 'Starte deine Traumkarriere',
    subtitle: 'Schließe dich Grameen Bazar an und hilf mit, den ländlichen Handel in Bangladesch ins digitale Zeitalter zu bringen'
  },
  companyStats: [
    { value: '500+', label: 'Mitarbeitende' },
    { value: '10+', label: 'Büros' },
    { value: '98%', label: 'Mitarbeiterzufriedenheit' },
    { value: '100+', label: 'Trainingsprogramme' }
  ],
  jobsSection: { title: 'Offene Stellen', subtitle: 'Arbeite mit uns und entwickle deine Karriere' },
  labels: {
    featured: 'Hervorgehoben',
    postedSuffix: 'veröffentlicht',
    salary: 'Gehalt',
    deadline: 'Bewerbungsfrist'
  },
  buttons: {
    viewDetails: 'Details ansehen',
    apply: 'Bewerben',
    cancel: 'Abbrechen',
    submit: 'Bewerbung absenden',
    contact: 'Kontakt'
  },
  cta: {
    title: 'Keine passende Stelle gefunden?',
    subtitle: 'Melde dich bei uns. Wir informieren dich über neue Möglichkeiten.',
    contact: 'Kontakt'
  },
  form: {
    titleSuffix: ' - Bewerbungsformular',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    education: 'Ausbildung',
    experience: 'Berufserfahrung',
    uploadResume: 'Lebenslauf hochladen (PDF, DOC, DOCX)'
  },
  snackbar: { success: 'Deine Bewerbung wurde gesendet. Wir melden uns in Kürze.' }
};

export default careerDe;


